export default function getTimeplanUnitsForDate(timeplanUnits, date) {
  return timeplanUnits.filter(timeplanUnit => timeplanUnit.get('date') === date);
}
